import BannerHomepage from './banner--homepage.js';

export default BannerHomepage;
